// extracted by mini-css-extract-plugin
export default {"titleList":"IngridientsBlock_titleList__amBrS","columns":"IngridientsBlock_columns__v0-BO","items":"IngridientsBlock_items__d+fuH"};